import {
  ApiNetworkError,
  ApiNotFoundError,
  ApiServerError,
  classifyApiError,
} from '@/services/apiError';
import ErrorState from '@/components/common/ErrorState';

interface ContentErrorProps {
  message?: string;
  retryLabel?: string;
  onRetry?: () => void;
}

interface ContentApiErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ContentNotFound({
  message = 'This item was not found or may have been removed.',
  retryLabel,
  onRetry,
}: ContentErrorProps) {
  return <ErrorState message={message} retryLabel={retryLabel} onRetry={onRetry} />;
}

export function ContentServiceUnavailable({
  message = 'The backend service is temporarily unavailable.',
  retryLabel,
  onRetry,
}: ContentErrorProps) {
  return <ErrorState message={message} retryLabel={retryLabel} onRetry={onRetry} />;
}

export function ContentLoadError({
  message = 'Failed to load this content. Please try again.',
  retryLabel,
  onRetry,
}: ContentErrorProps) {
  return <ErrorState message={message} retryLabel={retryLabel} onRetry={onRetry} />;
}

export default function ContentApiErrorState({ error, onRetry, retryLabel }: ContentApiErrorStateProps) {
  const classified = classifyApiError(error);

  if (classified instanceof ApiNotFoundError) {
    return <ContentNotFound onRetry={onRetry} retryLabel={retryLabel} />;
  }

  if (classified instanceof ApiNetworkError || classified instanceof ApiServerError) {
    return <ContentServiceUnavailable onRetry={onRetry} retryLabel={retryLabel} />;
  }

  return <ContentLoadError onRetry={onRetry} retryLabel={retryLabel} />;
}
